import { UserConst } from "@constants/user-const";
import { COMPANY } from "@constants/company-data";
import { BASE } from "@constants/common-data";

/**
 * 사용자 데이터
 */
export const UserData = {
  roles: {
    label: "",
    desc: "",
    items: [
      {
        text: "고객",
        value: 1,
      },
      {
        text: "견적자",
        value: 2,
      },
      {
        text: "관리자",
        value: 3,
      },
      {
        text: "운영자",
        value: 4,
      },
    ],
  },

  signalType: {
    create: 0,
    update: 1,
  },

  workStatus: [
    {
      text: "재직",
      value: "재직",
    },
    {
      text: "휴직",
      value: "휴직",
    },
    {
      text: "퇴직",
      value: "퇴직",
    },
  ],
  role: [
    {
      text: "고객",
      value: "고객",
    },
    {
      text: "견적자",
      value: "견적자",
    },
    {
      text: "관리자",
      value: "관리자",
    },
    {
      text: "운영자",
      value: "운영자",
    },
  ],
  accountStatus: [
    {
      text: "정상",
      value: "정상",
    },
    {
      text: "정지",
      value: "정지",
    },
    {
      text: "임시",
      value: "임시",
    },
    {
      text: "삭제",
      value: "삭제",
    },
    {
      text: "탈퇴",
      value: "탈퇴",
    },
    {
      text: "계정만료",
      value: "계정만료",
    },
    {
      text: "신용만료",
      value: "신용만료",
    },
  ],

  customerType: {
    label: "",
    text: "",
    items: [
      {
        text: "개인고객",
        value: UserConst.CUSTOMER_TYPE_PERSONAL,
      },
      {
        text: "기업고객",
        value: UserConst.CUSTOMER_TYPE_ENTERPRISE,
      },
    ],
  },
  companyName: {
    label: "상호명",
    desc: "",
    placeholder: "20 자리 이하의 문자",
  },
  name: {
    label: {
      name: "이름",
      operator: "담당자",
    },
    desc: "",
    placeholder: "2 ~ 20 자리 문자",
  },
  gender: {
    label: "성별",
    desc: "",
    items: [
      {
        text: "남",
        value: UserConst.GENDER_MALE,
      },
      {
        text: "여",
        value: UserConst.GENDER_FEMALE,
      },
    ],
  },
  agriRegistered: {
    label: "",
    text: "",
    items: [
      {
        text: "등록",
        value: true,
      },
      {
        text: "미등록",
        value: false,
      },
    ],
  },
} as const;

export const USER: User = {
  ...BASE,
  passwordConfirm: null,
  oldPassword: null,
  username: null,
  password: null,
  name: null,
  gender: null,
  birthdate: null,
  regNumber: null,
  email: null,
  address: {
    postcode: null,
    road: null,
    jibeon: null,
    detail: null,
  },
  mobileNumber: null,
  profileImage: null,
  phoneNumber: null,
  classType: null,
  role: null,
  roles: [
    {
      id: null,
      createDate: null,
      dbUpdate: null,
      authorities: null,
      description: null,
      rolename: null,
    },
  ],
  accountStatus: UserConst.accountStatus.NORMAL,
  authStatus: false,
  emailAuthStatus: false,
  mobileAuthStatus: false,
  passwordLastUpdate: null,
  lastLoginDate: null,
  lastUpdate: null,
  chargeRateSystem: null,
};

export const BUSINESS_USER: BusinessUser = {
  ...USER,
  company: COMPANY,
  id: null,
  companyMobileNumber: null,
  companyPhoneNumber: null,
  companyFaxNumber: null,
  memberDept: null,
  memberRank: null,
  memberDuty: null,
  workStatus: UserConst.workStatus.EMPLOYMENT,
};

export const CUSTOMER_USER: CustomerUser = {
  ...USER,
  customerType: UserConst.customerType.PERSONAL,
  agriRegistered: false,
  agriRegNumber: null,
  note: null,
  companyName: null,
  ceoName: null,
  businessType: null,
  businessTypeDetail: null,
  faxNumber: null,
  creator: null,
  lastUpdater: null,
};
